import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody} from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import Select from "react-select";
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import { SemanticToastContainer,  toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import ReactPhoneInput from 'react-phone-input-2';
import { API_BASE_URL } from "../utils/endpoints";

var value_option=[]
var groupOptions = []
var groups_array=[]
var data_group=[]
class EditContact extends React.Component {

  constructor(props) {
     super(props);
     this.state = {
       mobile: '',
       firstname: '',
       secondname: '',
       familyname: '',
       job: '',
       company: '',
       selectedValues: [],
       groupselect:'',
         group_id:'',
         options_sender:[],
         custom_filter1:'',
         custom_filter2:'',
         custom_filter3:'',
         custom_filter4:'',
         custom_filter5:'',
         custom_filter6:'',
         area: '',
        country: '',
        district:'',
        governerate:''
     }
    
   }

   componentWillMount() {
        

      var token=reactLocalStorage.get('accessToken');
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/"+reactLocalStorage.get('id_user_edit')+"/findcontact";
       }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/"+reactLocalStorage.get('id_user_edit')+"/findcontact"; 
      }
   
   var object={}
      var headers = {'Content-Type': 'application/json', 'token' :token }
   axios.get(apiBaseUrl,{headers: headers})
       .then(res => {
   
         if(res.data !== undefined)
           {
            this.setState({
              selectedValues: res.data.result.contact.groups ,
              company: res.data.result.contact.company ,
              job: res.data.result.contact.job ,
              mobile: res.data.result.contact.mobile_number ,
               firstname: res.data.result.contact.first_name ,
               secondname: res.data.result.contact.second_name ,
               familyname :res.data.result.contact.family_name,
               custom_filter1:res.data.result.contact.custom_filter1,
               custom_filter2:res.data.result.contact.custom_filter2,
               custom_filter3:res.data.result.contact.custom_filter3,
               custom_filter4:res.data.result.contact.custom_filter4,
               custom_filter5:res.data.result.contact.custom_filter5,
               custom_filter6:res.data.result.contact.custom_filter6,
               area: res.data.result.contact.area,
               country:res.data.result.contact.country,
               district:res.data.result.contact.district,
              governerate:res.data.result.contact.governerate
              });
             const dataoption=res.data.result.contact.groups;
             var length=res.data.result.contact.groups.length;
             var i;
            
             for(i=0;i<length;i++)
             {
             object={label:dataoption[i].group_name,value:dataoption[i].group_id};
             value_option.push(object);
             data_group.push(object);
             }
               value_option=JSON.stringify(value_option);
              
               this.setState({job:this.state.job})
           }
        })



   }
   handleChangearea = event =>
   {
         this.setState({ area: event.target.value});
   }
   handleChangecountry = event =>
   {
         this.setState({ country: event.target.value});
   }
   handleChangedistrict = event =>
   {
         this.setState({ district: event.target.value});
   }
   handleChangegovernerate = event =>
   {
         this.setState({ governerate: event.target.value});
   }
   handleChangecustom_filter1 = event =>
   {
         this.setState({ custom_filter1: event.target.value});
   }
   handleChangecustom_filter2 = event =>
{
    this.setState({ custom_filter2: event.target.value});
}
handleChangecustom_filter3 = event =>
{
    this.setState({ custom_filter3: event.target.value});
}
handleChangecustom_filter4 = event =>
{
    this.setState({ custom_filter4: event.target.value});
}
handleChangecustom_filter5 = event =>
{
    this.setState({ custom_filter5: event.target.value});
}
handleChangecustom_filter6 = event =>
{
    this.setState({ custom_filter6: event.target.value});
}
   onChangegroup= event =>{
     groups_array=event;
  
}


  onChange(values) {

    this.setState({
      selectedValues: values
    });
  }
  back=()=>
  {
    window.location="contact";
  }


  handleChange = (value) =>
  {
    this.setState({ mobile: value })
    
  }


  handleChangefisrtname =event =>
  {
    
    this.setState({ firstname: event.target.value});
    if(event.target.value.length >15){
      toast({
        type: 'warning',
        title: i18n.t('warning.label'),
        description: i18n.t('Max_length_of_input_15_characters.label'),
        animation: 'bounce',
        time: 5000,
       
    });
    }
  }
  
  handleChangesecondname = event =>
  {
        this.setState({ secondname: event.target.value});
        if(event.target.value.length >15){
          toast({
            type: 'warning',
            title: i18n.t('warning.label'),
            description: i18n.t('Max_length_of_input_15_characters.label'),
            animation: 'bounce',
            time: 5000,
           
        });
  
  }
  }
  handleChangefamilyname = event =>
  {
        this.setState({ familyname: event.target.value});
        if(event.target.value.length >15){
          toast({
            type: 'warning',
            title: i18n.t('warning.label'),
            description: i18n.t('Max_length_of_input_15_characters.label'),
            animation: 'bounce',
            time: 5000,
           
        });
  
  }
  }
  handleChangejob = event =>
  {
        this.setState({ job: event.target.value});

  }
  handleChangecompany = event =>
  {
        this.setState({ company: event.target.value});

  }
  handleSubmit = event => {
    event.preventDefault();
    if(this.state.firstname.length >15 || this.state.secondname.length >15 || this.state.familyname.length >15){
      toast({
        type: 'warning',
        title: i18n.t('warning.label'),
        description: i18n.t('Max_length_of_input_15_characters.label'),
        animation: 'bounce',
        time: 5000,
       
    });
  
  }
    else{
    var token=reactLocalStorage.get('accessToken');
    var i;
    var newarrayGroups=[]
    if(groups_array.length == 0)
    {
      for(i=0;i<data_group.length;i++)
      {
      newarrayGroups.push({
        group_id:data_group[i].value,
        group_name:data_group[i].label,
      })
    }
    }
    else
    {
       for(i=0;i<groups_array.length;i++)
    {
      newarrayGroups.push({
        group_id:groups_array[i].value,
        group_name:groups_array[i].label,
      })
    }
    }
    const user = {
      'mobile_number': this.state.mobile,
      'first_name': this.state.firstname,
      'second_name':this.state.secondname,
      'family_name':this.state.familyname,
      'job':this.state.job,
      'company':this.state.company,
      'groups':newarrayGroups,
      'custom_filter1':this.state.custom_filter1,
        'custom_filter2':this.state.custom_filter2,
        'custom_filter3':this.state.custom_filter3,
        'custom_filter4':this.state.custom_filter4,
        'custom_filter5':this.state.custom_filter5,
        'custom_filter6':this.state.custom_filter6,
        'area': this.state.area,
        'country': this.state.country,
        'district':this.state.district,
        'governerate':this.state.governerate,
        'id':reactLocalStorage.get('id_user_edit')
    };
    var data=user;

   var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if(ip.includes(s2))
    {
      apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/updateContact";
     }
    else
    {
     apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/updateContact";  
    }


    var headers = {
     'Content-Type': 'application/json',
      'token' :token
      }
    axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
    {

    if(response.status === 200)
    {
     
      window.location="contact";

    }
    else if(response.status === 204){
    console.log("Something wrong");
    toast({
      type: 'error',
      title: i18n.t('error.label'),
      description:i18n.t('Something_wrong.label'),
      animation: 'bounce',
      time: 5000,

  });
    }
    })
    .catch(function (error) {
    console.log(error);
    toast({
      type: 'error',
      title: i18n.t('error.label'),
      description:i18n.t('Something_wrong.label'),
      animation: 'bounce',
      time: 5000,

  });
    });
  }
  }


  componentDidMount()
  {  

        var lang=i18n.language;
   if(lang ==="ar")
   {
     document.querySelector('.form_edit_form').style = 'text-align:right;';       
  
   
   }

   var token=reactLocalStorage.get('accessToken');
   var ip=API_BASE_URL;
   var s2 = "localhost:3000";
   var apiBaseUrl;
   if(ip.includes(s2))
   {
    apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/getGroups";     
   }
   else
   {
    apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/getGroups";
   }


   var headers = {'Content-Type': 'application/json', 'token' :token }
axios.get(apiBaseUrl,{headers: headers})
    .then(res => {

      if(res.data !== undefined)
        {
          const dataoption=res.data.result.groups;
          var length=res.data.result.groups.length;
          var i;
          const newArr = this.state.options_sender;
          for(i=0;i<length;i++)
          {
           var value_option=dataoption[i].group_name;

           newArr.push({
            label: value_option, 
            value:dataoption[i].id
          });
            
          }
          groupOptions= newArr;
          this.setState({mobile:this.state.mobile})
       }
     })

 }
render() {
  return (
    <div className="big_div">
    <Menutest/>
    <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} className="form_edit_form">
                <p className="h4 text-center py-4 text_style darked_color">{i18n.t('Edit_Contact.label')}</p>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('Mobile_Number.label')}
                </label>
             
                <ReactPhoneInput required="required" onlyCountries={["jo"]} defaultCountry={'jo'} onChange={this.handleChange} value={this.state.mobile}  excludeCountries={["il"]}/>

                <br />

                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('First_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="firstname"
                  onChange={this.handleChangefisrtname}
                  placeholder={this.state.firstname}
                  defaultValue={this.state.firstname}
                />
              <br/>

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
                {i18n.t('Second_Name.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="secondname"
                onChange={this.handleChangesecondname}
                placeholder={this.state.secondname}
                defaultValue={this.state.secondname}
              />
             <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
                {i18n.t('Family_Name.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="familyname"
                onChange={this.handleChangefamilyname}
                placeholder={this.state.familyname}
                defaultValue={this.state.familyname}
              />
  <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
                {i18n.t('Job.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="job"
                onChange={this.handleChangejob}
                placeholder={this.state.job}
                defaultValue={this.state.job}
              />
                <br/>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('Company.label')}
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="company"
                onChange={this.handleChangecompany}
                placeholder={this.state.company}
                defaultValue={this.state.company}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter1.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option1"
                onChange={this.handleChangecustom_filter1}
                placeholder={this.state.custom_filter1}
                defaultValue={this.state.custom_filter1}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter2.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option2"
                onChange={this.handleChangecustom_filter2}
                placeholder={this.state.custom_filter2}
                defaultValue={this.state.custom_filter2}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter3.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option3"
                onChange={this.handleChangecustom_filter3}
                placeholder={this.state.custom_filter3}
                defaultValue={this.state.custom_filter3}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter4.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option4"
                onChange={this.handleChangecustom_filter4}
                placeholder={this.state.custom_filter4}
                defaultValue={this.state.custom_filter4}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter5.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option5"
                onChange={this.handleChangecustom_filter5}
                placeholder={this.state.custom_filter5}
                defaultValue={this.state.custom_filter5}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('custom_filter6.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="option6"
                onChange={this.handleChangecustom_filter6}
                placeholder={this.state.custom_filter6}
                defaultValue={this.state.custom_filter6}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('area.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="area"
                onChange={this.handleChangearea}
                placeholder={this.state.area}
                defaultValue={this.state.area}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('country.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="country"
                onChange={this.handleChangecountry}
                placeholder={this.state.country}
                defaultValue={this.state.country}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('district.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="district"
                onChange={this.handleChangedistrict}
                placeholder={this.state.district}
                defaultValue={this.state.district}
              />
             <br/>
             <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
              >
              {i18n.t('governerate.label')}
                
              </label>
              <input
                type="text"
                id="defaultFormCardNameEx"
                className="form-control"
                name="governerate"
                onChange={this.handleChangegovernerate}
                placeholder={this.state.governerate}
                defaultValue={this.state.governerate}
              />
             <br/>
            
               <p className="h4 darked_color">{i18n.t('Groups.label')}</p>
               <Select
                    placeholder={i18n.t('select.label')}
                    fluid
                    isMulti
                    search
                    selection
                    options={groupOptions}
                    onChange={this.onChangegroup.bind(this)}
                    defaultValue={value_option}
                    
                />
                 <br />


                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_darked">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}
                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_darked">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    <SemanticToastContainer/>
    </div></div></div>
  );
}
}
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditContact);